<template>
  <Drawer
    width="710"
    title="编辑客户权限"
    v-model="drawerOpened"
    style="padding: 0"
  >
    <div class="drawer-content">
      <Form
        ref="formItem"
        :model="formItem"
        @submit.native.prevent
        label-position="top"
      >
        <div class="formItem-content">
          <div class="formItem-left">
            <FormItem
              label="评分"
              prop="rating"
            >
              <InputNumber
                :max="100"
                :min="0"
                v-model="formItem.rating"
                placeholder="评分"
              />
            </FormItem>
            <FormItem
              label="允许开发"
              prop="allowDev"
            >
              <RadioGroup v-model="isAllowDev">
                <Radio label="true">是</Radio>
                <Radio label="false">否</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              label="状态"
              prop="status"
            >
              <RadioGroup v-model="formItem.status">
                <Radio label="none">无</Radio>
                <Radio label="dev">开发中</Radio>
                <Radio label="supplying">供货中</Radio>
                <Radio label="receive">收尾款中</Radio>
                <Radio label="sue">起诉中</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              label="所属部门"
              prop="department"
            >
              <Select
                v-model="formItem.department"
                multiple
                filterable
              >
                <Option
                  v-for="department in departmentList"
                  :value="department._id"
                  :key="department._id"
                >{{ department.name }}</Option>
              </Select>
            </FormItem>
          </div>
          <div class="formItem-right">
            <FormItem
              label="开发人员"
              prop="devSales"
            >
              <Select
                v-model="formItem.devSales"
                multiple
                filterable
              >
                <Option
                  v-for="user in simpleUserList.filter((x) => !x.superAdmin)"
                  :value="user._id"
                  :key="user._id"
                >{{ user.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="维护人员"
              prop="maintainSales"
            >
              <Select
                v-model="formItem.maintainSales"
                multiple
                filterable
              >
                <Option
                  v-for="user in simpleUserList.filter((x) => !x.superAdmin)"
                  :value="user._id"
                  :key="user._id"
                >{{ user.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="回款人员"
              prop="paymentSales"
            >
              <Select
                v-model="formItem.paymentSales"
                multiple
                filterable
              >
                <Option
                  v-for="user in simpleUserList.filter((x) => !x.superAdmin)"
                  :value="user._id"
                  :key="user._id"
                >{{ user.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="销售可见"
              prop="salesVisibleMember"
            >
              <Select
                v-model="formItem.salesVisibleMember"
                multiple
                filterable
              >
                <Option
                  v-for="user in simpleUserList.filter((x) => !x.superAdmin)"
                  :value="user._id"
                  :key="user._id"
                >{{ user.name }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="技术可见"
              prop="techVisibleMember"
            >
              <Select
                v-model="formItem.techVisibleMember"
                multiple
                filterable
              >
                <Option
                  v-for="user in simpleUserList.filter((x) => !x.superAdmin)"
                  :value="user._id"
                  :key="user._id"
                >{{ user.name }}</Option>
              </Select>
            </FormItem>
          </div>
        </div>

        <FormItem style="margin-right: 20px">
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import department from "@/store/modules/department";
import { mapState, mapActions, mapGetters } from "vuex";
import lodash from "lodash";

export default {
  name: "EditCustomerPurviewDrawer",
  data() {
    return {
      drawerOpened: false,
      openedCustomer: null,
      customerName: null,
      isAllowDev: null,
      formItem: {
        techVisibleMember: null,
        salesVisibleMember: null,
        rating: null,
      },
      updateFormItem: {},
    };
  },
  computed: {
    ...mapState({
      totalRows: (state) => state.user.totalCounts,
      simpleUserList: (state) => state.user.simpleUserList,
      departmentList: (state) => state.department.departmentList,
    }),
  },
  methods: {
    ...mapActions({
      updateCustomer: "customer/updateCustomerAction",
    }),
    openDrawer(customer) {
      this.$refs["formItem"].resetFields();
      this.openedCustomer = customer;
      this.drawerOpened = true;
      if (customer) {
        this.customerName = customer.name;
        this.formItem.rating = customer.rating ? customer.rating : null;
        this.formItem.status = customer.status;
        this.isAllowDev = customer.allowDev.toString();
        this.formItem.departMent =
          customer.departMent && customer.departMent._id;
        this.formItem.devSales = customer.devSales?.map((x) => x._id);
        this.formItem.maintainSales = customer.maintainSales?.map((x) => x._id);
        this.formItem.paymentSales = customer.paymentSales?.map((x) => x._id);
        this.formItem.techVisibleMember = customer.techVisibleMember?.map(
          (x) => x._id
        );
        this.formItem.salesVisibleMember = customer.salesVisibleMember?.map(
          (x) => x._id
        );
      }
    },
    async handleSubmit(name) {
      try {
        switch (this.isAllowDev) {
          case "true":
            this.formItem.allowDev = true;
            break;
          case "false":
            this.formItem.allowDev = false;
            break;
        }
        if (this.openedCustomer) {
          let formItem = lodash.cloneDeep(this.formItem);
          for (const key in formItem) {
            if (
              Object.prototype.toString.call(this.openedCustomer[key]) ===
              "[object Object]"
            ) {
              if (formItem[key] === this.openedCustomer[key]._id) {
                delete formItem[key];
              }
            } else {
              if (formItem[key] === this.openedCustomer[key]) {
                delete formItem[key];
              }
            }
          }
          await this.updateCustomer({
            id: this.openedCustomer._id,
            data: formItem,
          });
        }
        this.$Message.success("保存成功!");
        this.drawerOpened = false;
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.formItem-content
  display flex
  justify-content space-between

.formItem-right, .formItem-left
  min-width 320px
</style>